/*

lazyloading pro některé JS moduly

lazyJs('/js/lazy/nouislider.js', 'noUiSlider', updateLazy);

*/
import wait from '../functions/wait';

export default function(url, variable = null, callback = null) {
  window.lazyJs = window.lazyJs || [];

  if (!window[variable] && window.lazyJs.indexOf(variable) === -1) {
    window.lazyJs.push(variable);

    let scriptEl = document.createElement('script');
    scriptEl.setAttribute('src', window.lazyJsFiles[url] || url);
    scriptEl.setAttribute('async', '');
    document.body.appendChild(scriptEl);

    if (variable) {
      wait(window, variable, callback);
    }
  }
  else {
    if (typeof callback === 'function') {
      callback();
    }
  }
}
